export enum SurveyDecision {
  APPROVED = 'Approved',
  PENDING = 'Pending',
  DECLINED = 'Declined'
}
